import { useRecoilValue } from 'recoil';
import { 
  uiSettingsState, 
  uiSettingsLoadingState, 
  uiSettingsErrorState,
  type UISettings,
  type TileData,
  type FileUploadSettings
} from '@/state/uiSettings';

// Re-export types for backward compatibility
export type { UISettings, TileData, FileUploadSettings };

/**
 * Hook to access UI settings from global Recoil state.
 * Settings are initialized once at app startup, eliminating redundant API calls.
 */
export const useUISettings = () => {
  const settings = useRecoilValue(uiSettingsState);
  const isLoading = useRecoilValue(uiSettingsLoadingState);
  const error = useRecoilValue(uiSettingsErrorState);
  
  return {
    settings,
    isLoading,
    error
  };
};
